import { PremiumPreviewType, PremiumPreviewStatus } from '../store/schema/PremiumPreviewData';
import {
    PREMIUM_SUGGESTIONS_EXPIRED_COUNT,
    PREMIUM_SUGGESTIONS_NEW_COUNT,
    COUNT_DAYS_NEW,
} from '../constants';
import { assertNever } from 'owa-assert';

/**
 * PremiumPreviewType represent the different experiments
 * this function returns the PremiumPreviewStatus based on the usage of the user
 * with the premium preview so far
 */
export function getPremiumPreviewStatus(
    premiumPreviewType: PremiumPreviewType,
    premiumSuggestionsCount: number,
    numerOfDaysLeft: number
): PremiumPreviewStatus {
    switch (premiumPreviewType) {
        case PremiumPreviewType.TimeBased:
            if (numerOfDaysLeft === COUNT_DAYS_NEW) {
                return PremiumPreviewStatus.New;
            }
            if (numerOfDaysLeft > 0) {
                return PremiumPreviewStatus.Activated;
            }
            return PremiumPreviewStatus.Expired;
        case PremiumPreviewType.CountBased:
            if (premiumSuggestionsCount === PREMIUM_SUGGESTIONS_EXPIRED_COUNT) {
                return PremiumPreviewStatus.Expired;
            }
            if (premiumSuggestionsCount > PREMIUM_SUGGESTIONS_NEW_COUNT) {
                return PremiumPreviewStatus.Activated;
            }
            return PremiumPreviewStatus.New;
        case PremiumPreviewType.TimeAndCountCombined:
        case PremiumPreviewType.None:
        case PremiumPreviewType.BasicSkittle:
            return PremiumPreviewStatus.Unknown;
        default:
            return assertNever(premiumPreviewType);
    }
}
